import { Check, ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToId } from "@/lib/api";

const SERVICES = [
  "Recherche de véhicules",
  "Achat",
  "Négociation",
  "Vente",
  "Remplacement",
  "Inspection mécanique",
  "Financement",
  "Livraison",
  "Entretien",
  "Planification des rendez-vous",
  "Gestion des réparations",
  "Suivi du véhicule",
  "Coordination des services",
  "Gestion de plusieurs véhicules",
];

export default function Concierge() {
  return (
    <section id="conciergerie" data-testid="concierge-section" className="py-24 md:py-32 lg:py-40 bg-anthracite/60 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gold/[0.05] blur-[120px] rounded-full pointer-events-none" />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Chapter number="04" label="Service privé de gestion automobile" />
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
                Votre conciergerie
                <br />
                <span className="gold-text">automobile privée.</span>
              </h2>
              <p className="mt-5 font-display text-lg sm:text-xl text-slate-300 italic">
                Nous gérons votre automobile. Vous profitez de votre temps.
              </p>
              <p className="mt-6 text-sm sm:text-base text-slate-400 font-light leading-relaxed">
                Conçu pour les entrepreneurs, professionnels, cadres, familles et clients qui souhaitent
                déléguer la gestion de leur véhicule — une conciergerie automobile véritablement
                personnalisée.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-9 inline-flex items-center gap-3 border border-gold/40 bg-gold/[0.07] rounded-full px-5 py-2.5" data-testid="concierge-pricing-badge">
                <span className="w-1.5 h-1.5 rounded-full bg-gold" />
                <span className="text-[11px] uppercase tracking-[0.2em] text-gold-light">
                  Service à la carte ou forfait annuel
                </span>
              </div>
              <div className="mt-8">
                <button data-testid="concierge-cta-discover" onClick={() => scrollToId("#contact")} className="btn-gold">
                  Découvrir la gestion privée <ArrowRight size={16} />
                </button>
              </div>
              <div className="mt-10 relative max-w-md rounded-2xl overflow-hidden border border-white/10">
                <img
                  src="/images/f150-tremor-chantier.jpg"
                  alt="Pick-up Ford F-150 Tremor noir sur un chantier de construction"
                  className="w-full h-56 object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/75 via-transparent to-transparent" />
                <p className="absolute bottom-4 left-5 right-5 text-xs text-slate-200 font-light italic">
                  Pendant que nous nous occupons de votre automobile, concentrez-vous sur votre vie et
                  votre entreprise.
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-6">
                Nous pouvons prendre en charge
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-1" data-testid="concierge-services-list">
                {SERVICES.map((s, i) => (
                  <div
                    key={s}
                    className="flex items-center gap-3 py-3.5 border-b border-white/[0.07] group"
                  >
                    <span className="w-6 h-6 rounded-full border border-gold/30 flex items-center justify-center shrink-0 group-hover:bg-gold/10 transition-colors">
                      <Check size={12} className="text-gold" />
                    </span>
                    <span className="text-sm text-slate-200 font-light">{s}</span>
                    <span className="ml-auto font-mono text-[10px] text-slate-600">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
